import {
	createRelayResource,
	RELAY_RESOURCE_TYPE,
} from '@atlassian/jira-relay-utils/src/services/resources/index.tsx';
import PreviewPanelRelayQuery, {
	type PreviewPanelQuery,
} from '@atlassian/jira-preview-panels/src/__generated__/PreviewPanelQuery.graphql';

export const previewPanelStateResource = createRelayResource<PreviewPanelQuery>({
	type: `${RELAY_RESOURCE_TYPE}_PREVIEW_PANEL`,
	getQuery: (_, { tenantContext: { cloudId } }) => ({
		parameters: PreviewPanelRelayQuery,
		variables: { cloudId },
		options: { fetchPolicy: 'store-and-network' },
	}),
	isCritical: true,
	isBrowserOnly: false,
});
